import { getJSON } from "../../shared_component/utils/fetch"
import {
  SET_REWARDS_DATA,
  SET_REWARDS_EARNED_MILES,
  SET_REWARDS_HISTORY
} from "../reducers/rewards"

const REWARDS_BASE_URL = `${process.env.REACT_APP_INTERNAL_API_URL}/api/ecosystem/v1`

const GET_REWARDS = `${REWARDS_BASE_URL}/rewards`
const EARNED_MILES = `${REWARDS_BASE_URL}/rewards/earned_miles`
const REWARDS_HISTORY = `${REWARDS_BASE_URL}/rewards/history`

export const TYPE = "type"

export const setRewardsData = (data) => {
  return {
    type: SET_REWARDS_DATA,
    payload: data
  }
}

export const setEarnMiles = (data) => {
  return {
    type: SET_REWARDS_EARNED_MILES,
    payload: data
  }
}

export const setRewardsHistory = (data) => {
  return {
    type: SET_REWARDS_HISTORY,
    payload: data
  }
}

export function getRewards(payload) {
  return async function (dispatch, getState) {
    dispatch(setRewardsData([]))
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }
      let url = GET_REWARDS

      if (payload && payload.rewardType) {
        url = `${url}?${TYPE}=${payload.rewardType}`
      }

      const response = await getJSON(url, {}, request.headers)

      if (response.result) {
        dispatch(setRewardsData(response.result))
        return response
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      return response
    }
  }
}

export function getEarnedMiles(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }
      const url = EARNED_MILES

      const response = await getJSON(url, {}, request.headers)

      if (response.result) {
        dispatch(setEarnMiles(response.result))
        return response
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      return response
    }
  }
}

export function getRewardsHistory(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }

      const response = await getJSON(REWARDS_HISTORY, {}, request.headers)

      if (response.result) {
        dispatch(setRewardsHistory(response.result))
        return response
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      return response
    }
  }
}
